// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '66.279',
  className: null,
}

const propTypes = {
  width: PropTypes.string,
  className: PropTypes.string,
}

// Component
function IconSend({ width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 66.279 64.552"
      width={width}
    >
      <path
        fill="#0070f2"
        opacity="0.148"
        d="M35.81,0C49.92,0,51.1,3.223,51.1,16.905S37.817,37.71,25.548,41.678,0,30.587,0,16.905,21.7,0,35.81,0Z"
        transform="matrix(0.799, 0.602, -0.602, 0.799, 25.471, 0)"
      />
      <g transform="translate(8.151 16.737)">
        <path
          fill="#0056bf"
          d="M261.922,282.163l-4.614-4.622a.769.769,0,0,0-1.313.543v10.774a.769.769,0,0,0,.526.729.76.76,0,0,0,.243.04.769.769,0,0,0,.615-.308l4.614-6.152A.769.769,0,0,0,261.922,282.163Z"
          transform="translate(-237.54 -258.874)"
        />
        <path
          fill="#fff"
          d="M218.943,300.333l-4.614-1.538a.769.769,0,0,0-.974.972l3.076,9.228a.769.769,0,0,0,.73.526h.048a.769.769,0,0,0,.706-.615l1.538-7.69A.769.769,0,0,0,218.943,300.333Z"
          transform="translate(-197.938 -278.767)"
        />
        <path
          fill="#127ef8"
          d="M115.754,21.659a.769.769,0,0,0-.826-.035L85.707,38.542a.769.769,0,0,0,.143,1.395l13.811,4.6,10.735,4.6a.769.769,0,0,0,1.06-.574l4.614-26.146A.769.769,0,0,0,115.754,21.659Z"
          transform="translate(-79.172 -21.52)"
        />
        <g transform="translate(0 0.224)">
          <path
            fill="#fff"
            d="M236.412,22.58c.248-.345.29-.493.154-.6-.2-.165-.338.062-.6.331L215.611,43.075l5.787,2Z"
            transform="translate(-200.067 -21.922)"
          />
          <path
            fill="#fa6383"
            d="M1.88,386.727a.769.769,0,0,1-.521-.2q-.575-.529-1.132-1.087a.769.769,0,0,1,1.087-1.089q.535.535,1.087,1.044a.769.769,0,0,1-.521,1.335Z"
            transform="translate(0 -358.204)"
          />
          <path
            fill="#fa6383"
            d="M63.786,435.562a11.071,11.071,0,0,1-2.205-.229.769.769,0,0,1,.248-1.518l.059.012a9.537,9.537,0,0,0,1.9.2h.351a.729.729,0,0,1,.8.74.769.769,0,0,1-.74.8h-.4Zm-5.511-1.472a.769.769,0,0,1-.354-.086,20.082,20.082,0,0,1-2.186-1.327.769.769,0,0,1,.877-1.263,18.244,18.244,0,0,0,2.015,1.23.769.769,0,0,1-.354,1.452Z"
            transform="translate(-51.43 -401.972)"
          />
          <path
            fill="#fa6383"
            d="M216.257,450.456a.769.769,0,0,1-.308-1.477,11.161,11.161,0,0,0,1.287-.652.769.769,0,0,1,.781,1.324,12.772,12.772,0,0,1-1.464.743A.771.771,0,0,1,216.257,450.456Z"
            transform="translate(-199.947 -417.689)"
          />
        </g>
      </g>
    </svg>
  )
}

IconSend.defaultProps = defaultProps
IconSend.propTypes = propTypes

export default IconSend
